import { Button, CircularProgress } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { duplicateSharedSetting, getCopyTriggerSetting } from '../../api/globalApi';
import './sharePage.css';

const TriggerSharePage = () => {

    const { triggerId } = useParams();
    const [copySetting, setCopySetting] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        getCopyTriggerSetting({triggerString : triggerId}).then(res => {
            setCopySetting({
                trigger : res.data.data.trigger,
                user : res.data.data.userName,
                success : res.data.success
            });
        }); 
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleCopyTrigger = () => {
        setSubmitting(true);
        duplicateSharedSetting({triggerString : triggerId}).then(res => {
            if(res.data.success){
                window.location.href = "/trigger/settings/"+res.data.data.triggerId;
            } else {
                window.showNotification('ERROR','Unable to duplicate the trigger.');
                setSubmitting(false);
            }
        });
    }

    return ( 
        <div className="share_page__wrapper trigger_share">
            <div className="share_page__inner_wrapper">
            {
                !copySetting ?
                <>
                <h5><CircularProgress/> Loading</h5>
                </> : copySetting.success ? 
                <>
                    <h5>{copySetting.user} shared the trigger - "{copySetting.trigger}" with you.</h5>
                    <p>To copy this trigger, please click the button.</p>
                    <Button disabled={submitting} onClick={() => handleCopyTrigger()} className="accent--bg--text--color" size="large" startIcon={<FileCopy/>}>{submitting ? "Please wait" : "Copy Trigger"}</Button>
                </> :
                <>
                    <h5>Sorry! This trigger is already copied or removed.</h5>
                    <h5>Please contact with your provider.</h5>
                </> 
                
            }
                
            </div>
        </div> 
    );
}
 
export default TriggerSharePage;